export enum IntegrationsStoreModalAnalytics {
  CREATE_INTEGRATION_FORM_SUBMIT = 'Create Integration Form Submit - [Integrations Store Modal]',
  UPDATE_INTEGRATION_FORM_SUBMIT = 'Update Integration Form Submit - [Integrations Store Modal]',
  SELECT_PROVIDER_CLICK = 'Select Provider Click - [Integrations Store Modal]',
  CLOSE_MODAL = 'Close Modal - [Integrations Store Modal]',
}
